export default __webpack_public_path__ + "static/media/wave-partition.a5416675.png";